/**
 * The one place on this screen that renders a bespoke overlay instead of the
 * shared error modal, and it is design-mandated, not a preference. 44.4
 * point 2 specifies a TITLE, a body, and TWO buttons with a named primary.
 * `ErrorModalHost` renders one sentence, the machine code, and a single
 * dismiss; it structurally cannot render this. Do not "fix" this back into
 * the shared modal.
 */
import { Button, Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  PROVIDER_CONFLICT_BODY,
  PROVIDER_CONFLICT_CANCEL_LABEL,
  PROVIDER_CONFLICT_PRIMARY_LABEL,
  providerConflictTitle,
} from "./signInMethodsScreenLogic";

export type typeProviderConflictDialogProps = {
  /** undefined means closed. */
  provider: "apple" | "google" | undefined;
  onClose: () => void;
};

export const ProviderConflictDialog = ({
  provider,
  onClose,
}: typeProviderConflictDialogProps): ReactNode => (
  <Dialog
    open={provider !== undefined}
    onOpenChange={(next) => {
      if (!next) onClose();
    }}
    title={provider === undefined ? "" : providerConflictTitle(provider)}
    description={PROVIDER_CONFLICT_BODY}
    footer={
      <>
        <Button variant="secondary" onClick={onClose}>
          {PROVIDER_CONFLICT_CANCEL_LABEL}
        </Button>
        <Button onClick={onClose} data-testid="provider-conflict-try-another">
          {PROVIDER_CONFLICT_PRIMARY_LABEL}
        </Button>
      </>
    }
  >
    {null}
  </Dialog>
);
